/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.fixed-donate[_ngcontent-%COMP%] {\n    position: relative;\n    height: 30px;\n    width: 100%;\n    z-index: 999;\n}\n\n.donate[_ngcontent-%COMP%] {\n    position: absolute;\n    height: inherit;\n    width: inherit;\n    background-color: #555555;\n}\n\n.donate-text[_ngcontent-%COMP%] {\n    color: white;\n    padding-top: 5px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/app.component.css.shim.ngstyle.ts